import * as React from 'react';
import merge from 'lodash/merge';
import Chart from '../chart';
import { legend } from '../utils/commons';
import './css/commons.css';
var bubbleMapOptions = _ref => {
  var {
    theme
  } = _ref;
  return {
    chart: {
      borderWidth: 0
    },
    legend: merge(legend({
      theme
    }), {
      enabled: true,
      // @ts-expect-error it is a point in this case
      labelFormatter() {
        return "\n          <div style=\"cursor: default; display: flex;\">\n            <div style=\"height: ".concat(theme.layout.size4, "; width: ").concat(theme.layout.size4, "; margin-right: ").concat(theme.layout.size2, "; border-radius: ").concat(theme.borderRadius2, "; background-color: ").concat(this.color, ";\"/>\n          </div>\n          ").concat(this.name);
      },
      symbolHeight: 0,
      symbolPadding: 0,
      symbolWidth: 0
    }),
    plotOptions: {
      map: {
        borderColor: theme.palette.background.container,
        nullColor: theme.colorChartLine,
        showInLegend: false,
        zIndex: 0
      },
      mapbubble: {
        marker: {
          fillOpacity: 0.72,
          lineWidth: 0,
          states: {
            hover: {
              lineWidth: 8,
              lineColor: theme.colorChartMapBubbleHalo
            }
          }
        },
        maxSize: '12%',
        minSize: 4,
        states: {
          hover: {
            halo: null,
            lineWidthPlus: 0
          }
        },
        zIndex: 1
      },
      series: {
        events: {
          legendItemClick(e) {
            e.preventDefault();
          }
        }
      }
    },
    tooltip: {
      animation: false,
      backgroundColor: theme.colorChartTooltipBackground,
      borderRadius: parseInt(theme.borderRadius3.replace('px', ''), 10),
      borderWidth: 0,
      headerFormat: '',
      shadow: false,
      shape: 'square',
      style: {
        color: theme.colorChartTooltipForeground
      }
    }
  };
};
var GeospatialBubbleMap = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartOptions = React.useMemo(() => {
    return merge(options, bubbleMapOptions({
      theme
    }));
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    options: chartOptions,
    ref: ref,
    theme: theme,
    type: "mapChart"
  });
});
GeospatialBubbleMap.displayName = 'GeospatialBubbleMap';
export default GeospatialBubbleMap;